module.exports = __webpack_public_path__ + "static/media/ic-spinner.d6b574e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-spinner.svg
// module id = 787
// module chunks = 0